import module from 'kendu/legacy/module'

module.directive('currency', ($filter) => {
  const transform = $filter('currency')

  return {
    restrict: 'A',
    require: 'ngModel',
    link (scope, element, attrs, ngModel) {
      let roundTo = Number(attrs.currency) || 2
      let input = element[0]

      const render = () => {
        let value = ngModel.$modelValue

        if (input === document.activeElement) {
          input.type = 'number'
          input.value = ngModel.$isEmpty(value) ? value : value.toFixed(roundTo)
        } else {
          input.type = 'text'
          input.value = ngModel.$isEmpty(value) ? '' : transform(value, '$', roundTo)
        }
      }

      element.bind('focus', render)
      element.bind('blur', render)
      ngModel.$render = render
    },
  }
})



// WEBPACK FOOTER //
// ./src/deprecated/directive/currency/component.js